import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-position-history-grid',
  templateUrl: './position-history-grid.component.html',
  styleUrls: ['./position-history-grid.component.scss']
})
export class PositionHistoryGridComponent implements OnInit, DwModalHandler{
  item;
  configKeyPart;
  gridPreferences;
  filter;
  constructor() { }
  modalConfig: DwModalConfig<any>;
  closeModal: EventEmitter<DwModalResult<any>>;
  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<any>> {
    let result : DwModalResult = {
      cancelled: true,
      closeModal: true,
    }
    return of(result)
  }

  ngOnInit(): void {
    this.item = this.modalConfig.data.item
    this.configKeyPart = this.modalConfig.data.configKeyPart;
    this.gridPreferences = this.modalConfig.data.gridPreferences;
    this.filter = this.modalConfig.data.filter;
  }

}
